import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { NewTabMessage } from '../NewTabMessage'
import { ThemeColorContext } from 'shared/Components/ItemContent/context'

import './style.css.scss'

const NewTab = (props) => {
  const themeColor = useContext(ThemeColorContext)

  return (
    <div className="new-tab-container">
      <div
        className="item-name"
        style={{backgroundColor: themeColor}}>
        <h1>{props.item.name}</h1>
      </div>
      <NewTabMessage
        onClickNewTab={props.onClick}
        url={props.item.link_url} />
    </div>
  )
}

NewTab.propTypes = {
  item: PropTypes.object.isRequired,
  onClick: PropTypes.func
}

export default NewTab